<template>
  <b-card class="information-container">
    <div class="container-img">
      <template v-if="form.file != ''">
        <b-avatar
          ref="previewEl"
          badge-variant="light"
          class="user-avatar"
          size="130px"
        >
          <template #default>
            <b-img class="user-img" :src="form.file" fluid />
            <div class="avatar-buttons">
              <b-button
                variant="outline-danger"
                size="sm"
                @click="clearFileData"
                style="margin-right: 10px"
              >
                <feather-icon icon="TrashIcon" size="15" />
              </b-button>
              <b-button
                variant="outline-success"
                size="sm"
                @click="updatePhoto"
                style="margin-left: 10px"
              >
                <feather-icon icon="SaveIcon" size="15" />
              </b-button>
            </div>
          </template>
        </b-avatar>
      </template>

      <b-avatar v-else badge-variant="light" :src="user.image" size="130px">
        <template #badge>
          <feather-icon
            icon="Edit2Icon"
            class="cursor-pointer"
            id="edit-profile-img"
            size="17"
            @click="editProfile"
          ></feather-icon>
          <b-tooltip target="edit-profile-img" noninteractive>{{
            $t("Change Image Profile")
          }}</b-tooltip>
        </template>
      </b-avatar>

      <b-form-file
        ref="refInputEl"
        class="d-none"
        @change="fillFileData"
        accept="image/*"
      />

      <div class="mt-1 text-center">
        <div style="font-size: 15px" class="font-weight-bolder text-dark">
          {{ user.full_name | capitalize }}
        </div>
        <p class="text-secondary">{{ $t(user.role_name) | capitalize }}</p>
      </div>
    </div>
    <div class="container-info">
      <div class="information">
        <div class="text-secondary">Email</div>
        <div class="text-dark">
          {{ user.email }}
        </div>
      </div>
      <div class="information">
        <div class="text-secondary">{{ $t("Document Number") }}</div>
        <div class="text-dark">{{ user.user_name }}</div>
      </div>
      <div class="information">
        <div class="text-secondary">{{ $t("Cell Phone") }}</div>
        <div class="text-dark">
          {{ user.work_phone ? user.work_phone : "Por agregar" }}
        </div>
      </div>
      <div class="information">
        <div class="text-secondary">{{ $t("Start Date") }}</div>
        <div class="text-dark">
          {{ user.start_date ? user.start_date : "Por agregar" }}
        </div>
      </div>
      <!-- <div class="information">
        <div class="text-secondary">Tipo de Personal</div>
        <div class="text-dark">{{ user.type | capitalize }}</div>
      </div> -->
    </div>
  </b-card>
</template>

<script>
import UserService from "@/views/users/services/users.service.js";
export default {
  props: {
    userId: {
      type: Number,
      requred: true,
    },
  },

  data() {
    return {
      user: {},
      form: {
        file: "",
        image: "",
        remove: false,
        photo: "",
      },
    };
  },

  mounted() {
    this.getUserProfile();
  },

  methods: {
    async getUserProfile() {
      const params = {
        user_id: this.userId,
      };

      const { data } = await UserService.getUserProfile(params);
      this.user = data[0];
    },

    editProfile() {
      this.$refs.refInputEl.$el.childNodes[0].click();
    },

    async fillFileData(event) {
      await this.$refs.refInputEl.files;
      const image = this.$refs.refInputEl.files[0];
      this.form.image = image.name;

      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = () => (this.form.file = reader.result);
      this.form.size = image.size;
      this.form.type = image.type;
      this.form.remove = true;
      this.form.photo = image;
    },

    clearFileData() {
      this.form.file = "";
      this.form.image = "";
      this.form.remove = false;
      this.$refs.refInputEl.reset();
    },

    async updatePhoto() {
      try {
        this.addPreloader();
        const params = new FormData();
        params.append("photo", this.form.photo);
        params.append("namedoc", this.form.image);
        params.append("user_id", this.userId);
        params.append("size", this.form.size);
        params.append("type", this.form.type);
        const response = await UserService.updateProfile(params);
        console.log("updated: ", response);
      } catch (error) {
        console.log(error);
      } finally {
        this.removePreloader();
      }
    },
  },
};
</script>

<style scoped lang="scss">
.information-container {
  width: 100%;
  border-radius: 20px;
}

.container-img {
  width: 100%;
  height: 40%;
  display: flex;
  align-items: center;
  justify-content: start;
  flex-direction: column;
  border-bottom: 1px solid #e3e4e8;
}

.container-info {
  width: 100%;
  height: 60%;
  padding: 10px;
}

.information {
  margin: 10px 0;
}

.user-avatar {
  pointer-events: auto !important;
}

.user-img {
  border-radius: 5px !important;
  max-width: 100% !important;
  max-height: 230px !important;
  min-height: 230px !important;
}

.b-avatar-custom {
  align-items: unset !important;
}

.avatar-buttons {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0px;
  left: 0px;
  right: 0;
  bottom: 0;
  display: none;
  text-align: center;
  justify-content: center;
  align-items: center;
}

.user-avatar:hover .avatar-buttons {
  display: flex !important;
  background-color: rgba(0, 0, 0, 0.5) !important;
}
</style>